import { Text, Tooltip, TooltipFocusableTrigger } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";
import {
  YouTubeLogo,
  LoomLogo,
  SpotifyLogo,
  GoogleDocsLogo,
  GoogleSheetsLogo,
  GoogleCalendarLogo,
  FigmaLogo,
  NotionLogo,
  AirtableLogo,
} from "./Logos";
import styles from "./EmbedExamples.module.css";

const EMBEDDABLE_EXAMPLES = [
  { name: "YouTube", logo: YouTubeLogo },
  { name: "Google Sheets", logo: GoogleSheetsLogo },
  { name: "Google Calendar", logo: GoogleCalendarLogo },
  { name: "Google Docs", logo: GoogleDocsLogo },
  { name: "Airtable", logo: AirtableLogo },
  { name: "Notion", logo: NotionLogo },
  { name: "Figma", logo: FigmaLogo },
  { name: "Loom", logo: LoomLogo },
  { name: "Spotify", logo: SpotifyLogo },
  { name: "Image links (JPG, PNG, GIF, etc.)", icon: "actionPhoto" as const },
];

export function EmbedExamples() {
  return (
    <div className={styles.examplesSection}>
      <Text type="MinimalPrint1" color="TextInverted">
        Try linking to sites like…
      </Text>
      <div className={styles.logoRow}>
        {EMBEDDABLE_EXAMPLES.map(({ name, logo, icon }) => (
          <Tooltip key={name} content={name} placement="bottom">
            <TooltipFocusableTrigger>
              <div className={styles.logoContainer}>
                {icon ? (
                  <Icon name={icon} size={28} color="GrayWarm4" />
                ) : (
                  <img src={logo.src} alt={name} className={styles.logoImage} />
                )}
              </div>
            </TooltipFocusableTrigger>
          </Tooltip>
        ))}
      </div>
    </div>
  );
}
